import { render, staticRenderFns } from "./MyMentors.vue?vue&type=template&id=28a01f30&"
import script from "./MyMentors.vue?vue&type=script&lang=js&"
export * from "./MyMentors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports